module.exports = __webpack_public_path__ + "img/6stars.9d84fbf5.jpg";